export default function InstrucoesCard() {
  return (
    <div className="bg-body-emphasis p-4 rounded-4 border border-translucent mb-5">
      <h5 className="mb-3">Instruções</h5>
      <p className="fs-9 text-body-tertiary">
        A tag da versão deve seguir o padrão de versionamento semântico
        (SemVer):
      </p>
      <ul className="fs-9 text-body-tertiary mb-4">
        <li>Versão MAJOR: quando há mudanças incompatíveis</li>
        <li>
          Versão MINOR: quando adiciona funcionalidades mantendo compatibilidade
        </li>
        <li>Versão PATCH: quando corrige bugs mantendo compatibilidade</li>
      </ul>
      <p className="fs-9 text-body-tertiary">
        Exemplo: <code>v1.0.0</code>, <code>v2.3.1</code>
      </p>
      <hr className="my-4" />
      <h5 className="mb-3">URLs</h5>
      <p className="fs-9 text-body-tertiary">
        Clique em "Selecionar" para escolher URLs de arquivos disponíveis no
        servidor.
      </p>
      <p className="fs-9 text-body-tertiary mb-4">
        <span className="fw-semibold">Dica:</span> O sistema tentará detectar
        automaticamente a tag da versão a partir das URLs selecionadas. Arquivos
        com nomes como "backend-v1.2.3.zip" ou "installer-1.2.3.exe" terão suas
        versões extraídas automaticamente.
      </p>
      <hr className="my-4" />
      <h5 className="mb-3">Instalador</h5>
      <p className="fs-9 text-body-tertiary">
        Ao marcar uma versão como instalador, ela ficará disponível para
        download pelos usuários. Geralmente, apenas a versão mais recente deve
        estar marcada como instalador.
      </p>
    </div>
  );
}
